module.exports = __webpack_public_path__ + "media/flags/tf-8d05468a.svg";